import React, { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { requestCustomerResetToken } from '../../helpers/httpRequests/passwordReset';

export default function RequestTokenStep({ email, setEmail, onSuccess, emailReadOnly }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await requestCustomerResetToken(email);
      if (res?.error) {
        setError(res.message || 'Não foi possível enviar o código. Tente novamente.');
      } else {
        onSuccess();
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography mb={2}>
        Informe o e-mail da sua conta. Enviaremos um código para redefinir a senha.
      </Typography>
      <TextField
        label="E-mail"
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        fullWidth
        required
        margin="normal"
        disabled={emailReadOnly}
      />
      {error && <Typography color="error" mt={1}>{error}</Typography>}
      <Button
        type="submit"
        variant="contained"
        color="secondary"
        fullWidth
        disabled={loading || !email}
        sx={{ mt: 2 }}
      >
        {loading ? 'Enviando...' : 'Enviar código'}
      </Button>
    </form>
  );
}
